import {
  useTedWordReducer,
  TedWordContext,
  TedWordDispatchContext,
} from "app/ted-word/useTedWord";
import { STORAGE_KEY_PREFIX } from "app/utils/useResetableStorage";

interface TedWordProviderProps {
  roundIndex: number;
  children: React.ReactNode;
}

export function TedWordProvider(props: TedWordProviderProps) {
  const [roundState, dispatch] = useTedWordReducer(
    `${STORAGE_KEY_PREFIX}_TED_WORD_STATE_${props.roundIndex}`,
  );
  return (
    <TedWordContext value={roundState}>
      <TedWordDispatchContext value={dispatch}>
        {props.children}
      </TedWordDispatchContext>
    </TedWordContext>
  );
}
